var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditColumn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_37166)",
    filter: "url(#filter0_d_367_37166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 29.1667H8.33333C6.5 29.1667 5 27.6667 5 25.8334V9.16671C5 7.33337 6.5 5.83337 8.33333 5.83337H25C26.8333 5.83337 28.3333 7.33337 28.3333 9.16671V10.8334H25V9.16671H8.33333V25.8334H10V29.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2752 23.414C30.3141 23.1223 30.3335 22.8209 30.3335 22.5001C30.3335 22.189 30.314 21.8779 30.2654 21.5862L32.239 20.0501C32.4141 19.914 32.4627 19.6515 32.3557 19.457L30.4891 16.2292C30.3724 16.0154 30.1293 15.9473 29.9154 16.0154L27.5918 16.9487C27.1057 16.5792 26.5904 16.2681 26.0168 16.0348L25.6668 13.5654C25.6279 13.332 25.4335 13.1667 25.2002 13.1667H21.4668C21.2335 13.1667 21.0488 13.332 21.0099 13.5654L20.6599 16.0348C20.0863 16.2681 19.5613 16.589 19.0849 16.9487L16.7613 16.0154C16.5474 15.9376 16.3043 16.0154 16.1877 16.2292L14.3307 19.457C14.214 19.6612 14.2529 19.914 14.4474 20.0501L16.421 21.5862C16.3724 21.8779 16.3335 22.1987 16.3335 22.5001C16.3335 22.8015 16.3529 23.1223 16.4015 23.414L14.4279 24.9501C14.2529 25.0862 14.2043 25.3487 14.3113 25.5431L16.1779 28.7709C16.2946 28.9848 16.5377 29.0529 16.7515 28.9848L19.0752 28.0515C19.5613 28.4209 20.0765 28.732 20.6502 28.9654L21.0002 31.4348C21.0488 31.6681 21.2335 31.8334 21.4668 31.8334H25.2002C25.4335 31.8334 25.6279 31.6681 25.6571 31.4348L26.0071 28.9654C26.5807 28.732 27.1057 28.4209 27.5821 28.0515L29.9057 28.9848C30.1196 29.0626 30.3627 28.9848 30.4793 28.7709L32.346 25.5431C32.4627 25.3292 32.414 25.0862 32.2293 24.9501L30.2752 23.414ZM23.3335 26.0001C21.4085 26.0001 19.8335 24.4251 19.8335 22.5001C19.8335 20.5751 21.4085 19.0001 23.3335 19.0001C25.2585 19.0001 26.8335 20.5751 26.8335 22.5001C26.8335 24.4251 25.2585 26.0001 23.3335 26.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_367_37166",
    x: -4,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_37166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_367_37166",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_37166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColumn);
export default __webpack_public_path__ + "static/media/edit-column.561a73f2bc48eb739f0c64ba27abd873.svg";
export { ForwardRef as ReactComponent };